import { ServiceBase } from './ServiceBase'
import { ContentType } from './helpers/ContentType'
import { VestigingEnum, HistoryScope } from 'shared/models/Enum'
import { IKlantGroepModel } from 'shared/models/IKlantGroepModel'
import { ILocatieGlnMetKoppelingenModel } from 'shared/models/ILocatieGlnMetKoppelingenModel'
import { ILocatieGlnModel } from 'shared/models/ILocatieGlnModel'
import { IVolumewaardeModel } from 'shared/models/IVolumewaardeModel'
import {
  IKoppelGroepRequest,
  IPostKoppelRequest,
  IUpdateKoppelingRequest,
} from 'shared/models/PostRequestModel'
import { IKlant } from 'shared/models/IKlant'
import { IObjectResponse } from 'shared/models/IResponse'
import { IAarCombinatieSelectie } from 'shared/models/IAarCombinatieSelectie'
import { IKlantAfleverafspraak } from 'shared/models/IKlantAfleverafspraak'
import { IOrderType } from 'shared/models/IOrderType'
import { DeliveryLocationsOverviewModel } from 'shared/models/CutomerDeliveryLocations/DeliveryLocationsOverviewModel'
import { IKlantgroepAfleverafspraakModel } from 'shared/models/IKlantgroepAfleverafspraakModel'
import { IGlnLocatieZoekSelectie } from 'shared/models/IGlnLocatieZoekSelectie'
import { IGetOverflowTimeslotsFilters } from 'shared/models/IGetOverflowTimeslotsFilters'
import { IOverflowTimeslotModel } from 'shared/models/IOverflowTimeslotModel'
import { IProductDimension } from 'shared/models/IProductDimension'

export default class GlnService extends ServiceBase {
  //Gln dagadressen
  public static async getCustomerDeliveryAgreements(
    customerNumber: number,
    afspraakReferentie: string,
    warehouseId: VestigingEnum
  ): Promise<IObjectResponse<IKlant>> {
    let url = '/Klanten/customerDeliveryAgreements?'
    if (customerNumber && customerNumber > 0) {
      url += `customerNumber=${customerNumber}&`
    }
    if (warehouseId && warehouseId > 0) {
      url += `warehouseId=${warehouseId}&`
    }
    if (afspraakReferentie && afspraakReferentie.length > 0) {
      url += `deliveryAgreement=${afspraakReferentie}`
    }

    if (url.endsWith('&')) {
      url = url.slice(0, -1)
    }

    var result = await this.get<IKlant>(url, ContentType.Json)

    return result
  }

  // Klanten

  public static async getKlantGegevens(
    klantNummer: number
  ): Promise<IObjectResponse<IKlant>> {
    var result = await this.get<IKlant>(
      `/Klanten/klant/${klantNummer}`,
      ContentType.Json
    )
    return result
  }

  public static async getKlantGegevensById(
    klantId: number
  ): Promise<IObjectResponse<IKlant>> {
    var result = await this.get<IKlant>(
      `/Klanten/klant/Id/${klantId}`,
      ContentType.Json
    )
    return result
  }

  //Gln dagadressen
  public static async getCustomerLocationDeliveryAgreements(
    customerNumber: number,
    deliveyAgreementRefreence: string,
    locationName: string,
    warehouse: VestigingEnum,
    historyScope: HistoryScope
  ): Promise<IObjectResponse<DeliveryLocationsOverviewModel>> {
    let url = `/locations/deliveryLocationsOverview/${VestigingEnum[warehouse]}/${HistoryScope[historyScope]}?`
    if (customerNumber && customerNumber > 0) {
      url += `customerNumber=${customerNumber}&`
    }
    if (locationName && locationName.length > 0) {
      url += `locationName=${locationName}&`
    }
    if (deliveyAgreementRefreence && deliveyAgreementRefreence.length > 0) {
      url += `deliveryAgreement=${deliveyAgreementRefreence}`
    }

    if (url.endsWith('&')) {
      url = url.slice(0, -1)
    }

    var result = await this.get<DeliveryLocationsOverviewModel>(
      url,
      ContentType.Json
    )

    console.log(`response: ${JSON.stringify(result)}`)
    return result
  }

  public static async postKoppeling(
    request: IPostKoppelRequest
  ): Promise<IObjectResponse<string>> {
    var result = await this.postResponse<string>(
      `/Klanten/link`,
      request,
      ContentType.Text
    )
    return result
  }

  public static async postGroepKoppeling(
    request: IKoppelGroepRequest
  ): Promise<IObjectResponse<string>> {
    var result = await this.postResponse<string>(
      `/Klanten/groupLink`,
      request,
      ContentType.Text
    )
    return result
  }

  public static async updateKoppeling(
    request: IUpdateKoppelingRequest
  ): Promise<IObjectResponse<string>> {
    var result = await this.putResponse<string>(
      `/Klanten/link`,
      request,
      ContentType.Text
    )
    return result
  }

  public static async updateGroepKoppeling(
    request: IKoppelGroepRequest
  ): Promise<IObjectResponse<string>> {
    var result = await this.putResponse<string>(
      `/Klanten/groupLink`,
      request,
      ContentType.Text
    )
    return result
  }

  public static async updateKoppelingen(
    request: IUpdateKoppelingRequest[]
  ): Promise<IObjectResponse<string>> {
    var result = await this.postResponse<string>(
      `/Klanten/links`,
      request,
      ContentType.Text
    )
    return result
  }

  public static async postVerwijderKoppeling(
    vestiging: number,
    klantNummer: number,
    koppelingId: number
  ): Promise<IObjectResponse<string>> {
    var result = await this.delete<string>(
      `/Klanten/link/${vestiging}/${klantNummer}/${koppelingId}`,
      ContentType.Text
    )
    return result
  }

  public static async postVerwijderGroepKoppeling(
    vestiging: number,
    klantNummer: number,
    koppelingId: number
  ): Promise<IObjectResponse<string>> {
    var result = await this.delete<string>(
      `/Klanten/groupLink/${vestiging}/${klantNummer}/${koppelingId}`,
      ContentType.Text
    )
    return result
  }

  public static async getKoppelingenPerVestiging(
    vestiging: VestigingEnum
  ): Promise<IObjectResponse<IKlant[]>> {
    var result = await this.get<IKlant[]>(
      `/Klanten/customerDeliveryAgreements/${vestiging}`,
      ContentType.Json
    )

    if (result.success) {
      result.payLoad = result.payLoad.sort((a, b) =>
        a.klantNummer > b.klantNummer ? 1 : -1
      )
    }
    return result
  }

  public static async getAfleverafsprakenPerVestigingPerKlant(
    vestiging: number,
    klantNummer: number
  ): Promise<IObjectResponse<IKlantAfleverafspraak[]>> {
    var result = await this.get<IKlantAfleverafspraak[]>(
      `/afleverafspraak/afleverafspraken/${vestiging}/${klantNummer}`,
      ContentType.Json
    )
    return result
  }

  public static async getAfleverafsprakenZonderLocatie(): Promise<
    IObjectResponse<IKlantAfleverafspraak[]>
  > {
    var result = await this.get<IKlantAfleverafspraak[]>(
      `/Klanten/agreementsWithoutLink`,
      ContentType.Json
    )

    return result
  }

  public static async getKoppelingenVoorCombinaties(
    request: IAarCombinatieSelectie
  ): Promise<IObjectResponse<ILocatieGlnModel[]>> {
    var result = await this.get<ILocatieGlnModel[]>(
      `/Gln/combinations/${request.vestiging}?customerNumber=${
        !!request.klantnummer ? request.klantnummer : ''
      }&reference=${
        !!request.afspraakreferentie ? request.afspraakreferentie : ''
      }&locationGln=${!!request.locatieGln ? request.locatieGln : ''}`
    )

    return result
  }

  // Locaties

  public static async getKoppelLocaties(
    omschrijving: string,
    vestiging: VestigingEnum
  ): Promise<IObjectResponse<ILocatieGlnModel[]>> {
    var result = await this.get<ILocatieGlnModel[]>(
      `/Gln/locaties/${vestiging}/${omschrijving}`,
      ContentType.Json
    )
    return result
  }

  public static async GetLocatieGlnsPerVestiging(
    vestiging: VestigingEnum
  ): Promise<IObjectResponse<ILocatieGlnModel[]>> {
    var result = await this.get<ILocatieGlnModel[]>(
      `/Gln/locaties/${vestiging}`,
      ContentType.Json
    )
    if (result.success) {
      result.payLoad = result.payLoad.sort((a, b) =>
        a.locatieGlnCode > b.locatieGlnCode ? 1 : -1
      )
    }
    return result
  }

  public static async SearchCustomerLocationLinks(
    searchParameters: IGlnLocatieZoekSelectie
  ): Promise<IObjectResponse<ILocatieGlnMetKoppelingenModel[]>> {
    let url = '/Gln/zoekklantlocationkoppelingen?'
    if (searchParameters.klantNummer && searchParameters.klantNummer > 0) {
      url += `customerNumber=${searchParameters.klantNummer}&`
    }
    if (searchParameters.locatieGln && searchParameters.locatieGln > 0) {
      url += `locationGlnCode=${searchParameters.locatieGln}&`
    }
    if (searchParameters.klantNaam) {
      url += `customerName=${searchParameters.klantNaam}&`
    }
    if (searchParameters.locatieNaam) {
      url += `locationName=${searchParameters.locatieNaam}&`
    }
    if (searchParameters.afleverAfspraakReferentie) {
      url += `deliveryAgreementReference=${searchParameters.afleverAfspraakReferentie}&`
    }
    if (searchParameters.weekDag) {
      url += `dayOfWeek=${searchParameters.weekDag}&`
    }
    if (searchParameters.koppelingType) {
      url += `locationLinkType=${searchParameters.koppelingType}&`
    }
    url += `warehouse=${searchParameters.vestiging}`

    var result = await this.get<ILocatieGlnMetKoppelingenModel[]>(url)
    return result
  }

  public static async GetLocatieGlnMetGekoppeldeKlanten(
    locatieGln: number
  ): Promise<IObjectResponse<ILocatieGlnMetKoppelingenModel>> {
    var result = await this.get<ILocatieGlnMetKoppelingenModel>(
      `/Gln/zoeklocatie/${locatieGln}`,
      ContentType.Json
    )
    return result
  }

  public static async GetLocatieGlnMetGekoppeldeKlantenByName(
    locatieNaam: string
  ): Promise<IObjectResponse<ILocatieGlnMetKoppelingenModel[]>> {
    var result = await this.get<ILocatieGlnMetKoppelingenModel[]>(
      `/Gln/zoeklocatieopnaam/${locatieNaam}`,
      ContentType.Json
    )
    return result
  }

  // Klantgroepen

  public static async postKlantgroep(
    request: Omit<IKlantGroepModel, 'isUsedAsOverflow'>
  ): Promise<IObjectResponse<string>> {
    var result = await this.postResponse<string>(
      `/KlantGroep/klantgroepen`,
      request,
      ContentType.Text
    )

    return result
  }

  public static async verwijderKlantgroep(
    request: IKlantGroepModel
  ): Promise<IObjectResponse<string>> {
    const r = {
      ...request,
      vestigingCode: +request.vestigingCode,
      klantGroepCode: +request.klantGroepCode,
      doorlooptijdInMinuten: +request.doorlooptijdInMinuten,
    }
    var result = await this.postResponse<string>(
      `/KlantGroep/verwijderKlantgroep`,
      r,
      ContentType.Text
    )

    return result
  }

  public static async getKlantgroepen(
    vestiging: VestigingEnum,
    code: number
  ): Promise<IObjectResponse<IKlantGroepModel[]>> {
    var result = await this.get<IKlantGroepModel[]>(
      `/KlantGroep/klantgroepen?vestiging=${
        vestiging == null ? '' : vestiging
      }&code=${code == null ? '' : code}`,
      ContentType.Json
    )
    return result
  }

  public static async getPossibleOrderTypes(): Promise<
    IObjectResponse<IOrderType[]>
  > {
    var result = await this.get<IOrderType[]>(
      `/KlantGroep/possibleordertypes`,
      ContentType.Json
    )
    return result
  }

  // Klantgroepkoppelingen
  public static async getKlantgroepkoppelingen(
    afleverAfspraakreferentie: string,
    vestiging: VestigingEnum,
    klantNummer: number,
    klantNaam: string,
    klantGroepId: number
  ): Promise<IObjectResponse<IKlantgroepAfleverafspraakModel[]>> {
    var result = await this.get<IKlantgroepAfleverafspraakModel[]>(
      `/KlantgroepAfleverafspraak/klantgroepafleverafspraken?vestiging=${
        vestiging === undefined ? '' : vestiging
      }
            &afleverAfspraakreferentie=${
              afleverAfspraakreferentie === undefined
                ? ''
                : afleverAfspraakreferentie
            }
            &klantNummer=${klantNummer === undefined ? '' : klantNummer}
            &klantNaam=${klantNaam === undefined ? '' : klantNaam}
            &klantGroepId=${klantGroepId === undefined ? '' : klantGroepId}`,
      ContentType.Json
    )
    return result
  }

  public static async postKlantgroepAfleverafspraak(
    request: IKlantgroepAfleverafspraakModel
  ): Promise<IObjectResponse<string>> {
    var result = await this.postResponse<string>(
      `/KlantgroepAfleverafspraak/klantgroepafleverafspraak`,
      {
        klantgroepAfleverafspraakId: request.klantgroepAfleverafspraakId,
        klantafleverAfspraakId: request.klantAfleverAfspraakId,
        klantGroepId: request.klantGroepId,
        vestiging: request.vestiging,
        klantId: request.klantId,
      },
      ContentType.Text
    )
    return result
  }

  public static async verwijderKlantgroepAfleverafspraak(
    request: IKlantgroepAfleverafspraakModel
  ): Promise<IObjectResponse<string>> {
    var result = await this.postResponse<string>(
      `/KlantgroepAfleverafspraak/verwijderKlantgroepafleverafspraak`,
      request,
      ContentType.Text
    )
    return result
  }

  // Volumewaarden
  public static async getVolumewaarden(
    type: string,
    warehouseId: number
  ): Promise<IObjectResponse<IVolumewaardeModel[]>> {
    let address = `/Volumewaarde/volumewaarden/${warehouseId}`

    if (type != null) {
      address += `?type={type}`
    }

    var result = await this.get<IVolumewaardeModel[]>(address, ContentType.Json)

    return result
  }
  public static async postVolumewaarde(
    request: IVolumewaardeModel
  ): Promise<IObjectResponse<string>> {
    var result = await this.postResponse<string>(
      `/Volumewaarde/volumewaarden`,
      request,
      ContentType.Text
    )
    console.log('post result')
    console.log(result)

    return result
  }
  public static async verwijderVolumewaarde(
    request: IVolumewaardeModel
  ): Promise<IObjectResponse<string>> {
    var result = await this.postResponse<string>(
      `/Volumewaarde/verwijderVolumewaarde`,
      request,
      ContentType.Text
    )
    console.log('post result')
    console.log(result)

    return result
  }

  public static async getOverflowTimeslots(
    filters: IGetOverflowTimeslotsFilters
  ): Promise<IObjectResponse<IOverflowTimeslotModel[]>> {
    var result = await this.postResponse<IOverflowTimeslotModel[]>(
      `/KlantGroep/overflowtimeslots`,
      filters,
      ContentType.Json
    )
    return result
  }

  public static async getProductDimensions(): Promise<
    IObjectResponse<IProductDimension[]>
  > {
    return this.get<IProductDimension[]>(
      `/ProductDimension/productdimensions`,
      ContentType.Json
    )
  }

  public static async getProductDimension(
    productDimensionId: number
  ): Promise<IObjectResponse<IProductDimension>> {
    return this.get<IProductDimension>(
      `/ProductDimension/productdimension/${productDimensionId}`,
      ContentType.Json
    )
  }

  public static async postProductDimension(
    productDimension: IProductDimension
  ): Promise<IObjectResponse<IProductDimension>> {
    return this.postResponse<IProductDimension>(
      `/ProductDimension/productdimension`,
      productDimension,
      ContentType.Json
    )
  }

  public static async updateProductDimension(
    productDimension: IProductDimension
  ): Promise<IObjectResponse<IProductDimension>> {
    return this.putResponse<IProductDimension>(
      `/ProductDimension/productdimension`,
      productDimension,
      ContentType.Json
    )
  }

  public static async deleteProductDimension(
    productDimensionId: number
  ): Promise<IObjectResponse<{ productDimensionId: number }>> {
    return this.delete(
      `/ProductDimension/productdimension/${productDimensionId}`,
      ContentType.Json
    )
  }
}
